module.exports = __webpack_public_path__ + "img/3.769f7f3f.png";